import React from "react";
import { ModalClose } from "bcms-react";
import CustomModal, { CustomModalContent, CustomModalFooter, ModalPrimaryButton } from "components/custom-ui/CustomModal";
import AccountDetailsView from "components/shared/views/AccountDetailsView";

import "./styles.css";

export default function AccountDetailsModal(props) {
  return (
    <CustomModal title="Account Details" id="AccountDetailsModal" className="account-details-modal" dataPoint="Account_Details_Modal">
      <CustomModalContent>
        <AccountDetailsView data={props.data} />
      </CustomModalContent>
      <CustomModalFooter>
        <ModalClose id="AccountDetailsModal">
          <ModalPrimaryButton text="Close" />
        </ModalClose>
      </CustomModalFooter>
    </CustomModal>
  );
}